import { z } from 'zod';
import { ProvisioningMethodSchema } from './product';

/**
 * GET /api/products レスポンスの型定義
 * エラーレスポンスは共通の types/errors.ts を参照すること。
 */

/** プロダクト一覧の各アイテム Zod スキーマ */
const ResProductSchema = z.object({
  product_id: z.string(),
  product_name: z.string(),
  provisioning_method: ProvisioningMethodSchema,
  team: z.string(),
  budget: z.string(),
  purpose: z.string(),
  description: z.string(),
  jira_url: z.string(),
  confluence_url: z.string(),
  teams_url: z.string(),
  github_url: z.string(),
  phase_id: z.number().int().nullable(),
  latest_release_date: z.string().nullable(),
  latest_release_version: z.string(),
  next_release_date: z.string().nullable(),
  next_release_version: z.string(),
  create_date: z.string(),
  update_date: z.string(),
});

/** GET /api/products レスポンス Zod スキーマ */
export const ProductListResponseSchema = z.object({
  products: z.array(ResProductSchema),
});

/** scope クエリパラメータの列挙型 Zod スキーマ */
export const ProductListScopeSchema = z.enum(['all', 'mine']);

/** プロダクト一覧の各アイテムの型 */
export type ResProduct = z.infer<typeof ResProductSchema>;

/** GET /api/products レスポンスの型 */
export type ProductListResponse = z.infer<typeof ProductListResponseSchema>;

/** scope クエリパラメータの型 */
export type ProductListScope = z.infer<typeof ProductListScopeSchema>;
